<template>
  <vue-dropzone
    ref="dropZoneRef"
    id="sender"
    :awss3="awss3"
    :options="options"
    @vdropzone-s3-upload-error="s3UploadError"
    @vdropzone-s3-upload-success="s3UploadSuccess"
    @vdropzone-removed-file="fileRemoved"
    :use-custom-slot="true">
    <div class="after-drop-message">
      <p>You may drag-and-drop an image here. File size must be less than {{options.maxFilesize}} MB.</p>
    </div>
  </vue-dropzone>
</template>

<script>
import VueDropzone from "vue2-dropzone";

const signingURL = f => `/api/uploads/get-direct-multipart-upload?file_name=${encodeURIComponent(f.name)}&file_size=${f.size}&file_type=${encodeURIComponent(f.type)}`

export default {
  props: ['value'],
  name: "DirectUploadPlayer",
  components: { VueDropzone },
  computed: {
    options() {
      return {
        addRemoveLinks: true,
        acceptedFiles: ".png,.jpg, image/png, image/jpeg",
        maxFiles: 1,
        maxFilesize: 2, // in Mb
        thumbnailWidth: "247",
        thumbnailHeight: "143",
        withCredentials: false
      }
    },
    awss3() {
      return {
        signingURL,
        sendFileToServer: false,
        withCredentials: false,
        headers: {
          'Accept': 'application/json'
        }
      };
    }
  },
  data() {
    return {
      hash: false,
    }
  },
  watch: {
    value(v) {
      if (!v || v === this.hash) {
        return;
      }
      let mime = this.value.split('.').reverse()[0];
      let file = { size: 225, name: 'Uploaded File', type: 'image/' + mime };
      this.$refs.dropZoneRef.manuallyAddFile(file, this.value);
    }
  },
  methods: {
    s3UploadError(e) {},
    s3UploadSuccess(f) {
      try {
        let hash = decodeURIComponent(f).split('/').reverse()[0].split('.')[0];
        this.hash = hash;
        this.$emit('input', hash);
      } catch (e) {
        // do nothing here with this input value
      }
    },
    fileRemoved() {
      this.$emit('input', '');
    }
  }
}
</script>

<style scoped>

</style>
